/***********************
 * CALENDAR COMPONENT (RANGE)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

//Formatting date
import dayjs from "dayjs"

//Translation
import { withTranslation } from "react-i18next"

//DatePicker ANTD
import { DatePicker } from "antd"
const { RangePicker } = DatePicker

const RangeCalendar = props => {
  const [defaultValueStart] = useState(
    props.defaultStart
      ? props.defaultStart
      : dayjs(dayjs().startOf("day")).add(-14, "days")
  )
  const [defaultValueEnd] = useState(
    props.defaultEnd ? props.defaultEnd : dayjs()
  )
  const [dateAndTime, setDateAndTime] = useState(null)

  useEffect(() => {
    if (dateAndTime == null) {
      props.setStartDate(defaultValueStart)
      props.setEndDate(defaultValueEnd)
    }
  }, [])

  const presetRanges = [
    {
      label: props.t("day"),
      value: [dayjs().subtract(1, "day").startOf("day"), dayjs()],
    },
    {
      label: props.t("7 days"),
      value: [dayjs().subtract(1, "week").startOf("day"), dayjs()],
    },
    {
      label: props.t("14 days"),
      value: [dayjs().subtract(2, "weeks").startOf("day"), dayjs()],
    },
    {
      label: props.t("month"),
      value: [dayjs().subtract(1, "month").startOf("day"), dayjs()],
    },
    {
      label: props.t("year"),
      value: [dayjs().subtract(1, "year").startOf("day"), dayjs()],
    },
  ]

  const onDateSelection = value => {
    setDateAndTime(value)
    if (value != null) {
      let start = new Date(value[0])
      let startUnix = start.getTime()
      /*console.log(
        "Start date: " +
          dayjs(startUnix).startOf("day").format("DD.MM.YYYY HH:mm:ss")
      )*/

      let end = new Date(value[1])
      let endUnix = end.getTime()
      /*console.log(
        "End date: " +
          dayjs(endUnix).endOf("day").format("DD.MM.YYYY HH:mm:ss")
      )*/

      props.setStartDate(dayjs(startUnix).startOf("day"))
      props.setEndDate(dayjs(endUnix).endOf("day"))
    }
  }

  // User can not pick a date further than end of the day
  const disabledDate = current => {
    const from = dayjs().subtract(dayjs(), "days")
    return (
      current &&
      (current > dayjs().endOf("day") || current < from.startOf("day"))
    )
    // return current && current > dayjs().endOf("day")
  }

  return (
    <React.Fragment>
      <div>
        <RangePicker
          disabled={props.disabled}
          disabledDate={disabledDate}
          defaultValue={[defaultValueStart, defaultValueEnd]}
          allowClear={false}
          style={{
            width: "100%",
          }}
          onChange={onDateSelection}
          format="DD.MM.YYYY"
          presets={presetRanges}
        />
      </div>
    </React.Fragment>
  )
}

RangeCalendar.propTypes = {
  t: PropTypes.any,
  setStartDate: PropTypes.any,
  setEndDate: PropTypes.any,
  disabled: PropTypes.any,
  defaultStart: PropTypes.any,
  defaultEnd: PropTypes.any,
}
export default withTranslation()(RangeCalendar)
